import ChatUI from "../components/ai-assistant/ChatUI";

const AIAssistant = () => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950 py-8 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">AI Assistant</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 max-w-2xl">
            Describe your symptoms to get non-diagnostic suggestions, urgency guidance, and matching doctors you can book instantly.
          </p>
        </div>
        <ChatUI />
      </div>
    </div>
  );
};

export default AIAssistant;
